import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { FormulaCatalogoService } from '../../../../shared/services/apis/motor-fiscal/formula-catalogo.service';
import { FormulaModeloEmpresaService } from '../../../../shared/services/apis/motor-fiscal/formula-modelo-empresa.service';
import { FormulaCatalogoGrupoStruct } from '../../../../shared/services/structs/formula/formula-catalogo-grupo.struct';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { TabsScrollDirective } from '../../../../shared/directives/tabs-scroll.directive';
import { DifaisListaComponent } from './tabs/difais-lista/difais-lista.component';
import { FormulasDifalTabComponent } from './tabs/formulas-lista/formulas-lista.component';

@Component({
    selector: 'app-tabela-difal-lista',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        MatButtonModule,
        MatIconModule,
        MatTabsModule,
        TabsScrollDirective,
        HeaderComponent,
        DifaisListaComponent,
        FormulasDifalTabComponent,
    ],
    templateUrl: './tabela-difal-lista.component.html',
    styleUrl: './tabela-difal-lista.component.css',
})
export class TabelaDifalListaComponent {
    public moduloEnum = ModuloEnum.Configuracoes;
    public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_NotasFiscais;

    public _gruposFormulas: FormulaCatalogoGrupoStruct[] = [];
    public _isLoadingFormulas: boolean = false;
    public _formulasCarregadas: boolean = false;

    constructor(
        private formulaService: FormulaCatalogoService,
        private formulaModeloEmpresaService: FormulaModeloEmpresaService,
        private alertService: AlertService,
    ) {}

    public onTabFormulasAtivada(): void {
        if (!this._formulasCarregadas) {
            this._isLoadingFormulas = true;
            this.formulaService.getContexto('difal').subscribe({
                next: response => {
                    this._isLoadingFormulas = false;
                    if (response.isError) {
                        this.alertService.show('Erro', response.errorDescription || 'Erro ao carregar fórmulas DIFAL', AlertType.error);
                        return;
                    }
                    this._gruposFormulas = response.grupos;
                    this._formulasCarregadas = true;
                },
                error: err => {
                    this._isLoadingFormulas = false;
                    this.alertService.show('Erro inesperado', err.message || 'Erro ao carregar catálogo DIFAL', AlertType.error);
                },
            });
        }
    }

    public alterarModeloEmpresa(selecao: { chaveFormula: string; chaveFormulaModelo: string }): void {
        this.formulaModeloEmpresaService.alterar(selecao.chaveFormula, selecao.chaveFormulaModelo).subscribe({
            next: response => {
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription || 'Não foi possível alterar o modelo.', AlertType.error);
                    return;
                }
                this._formulasCarregadas = false;
                this.onTabFormulasAtivada();
                this.alertService.show('Sucesso', 'Modelo da fórmula atualizado.', AlertType.success);
            },
            error: () => this.alertService.show('Erro', 'Não foi possível alterar o modelo.', AlertType.error),
        });
    }
}
